import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  updateFileName(event) {
    const file = event.target.files[0]
    if (file && file.name) {
      this.element.closest('.custom-file-input-wrapper').querySelector('.custom-file-name').textContent = file.name
    } else {
      this.element.closest('.custom-file-input-wrapper').querySelector('.custom-file-name').textContent = 'File uploaded'
    }
  }
} 